import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48f9b5b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-market" }

import { OtLozenge } from '@1trading/design-system';
import { computed, type PropType } from 'vue';
import { useRouter } from 'vue-router';

import type { OrderWithTradesModel } from '@exchange/libs/order/shared-model/src/lib/order-model';

import OrderSideIcon from './OrderSideIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderMarket',
  props: {
  order: { type: Object as PropType<OrderWithTradesModel>, required: true },
  withIcon: { type: Boolean, default: false },
  marketId: { type: String, default: '' },
  isCurrentMarketOrder: { type: Boolean, default: false },
  isFutures: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;

const router = useRouter();

const isLink = computed(() => !props.isCurrentMarketOrder);

const onIdClick = () => {
  router.push({
    name: 'spot',
    params: { marketId: props.order.instrumentCode },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_ot_market_id = _resolveComponent("ot-market-id")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.withIcon)
      ? (_openBlock(), _createBlock(OrderSideIcon, {
          key: 0,
          "is-buy": __props.order.isBuy
        }, null, 8, ["is-buy"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ot_market_id, {
      "market-id": __props.order.marketName,
      "is-link": isLink.value,
      "instrument-code": __props.order.instrumentCode,
      onClick: onIdClick
    }, null, 8, ["market-id", "is-link", "instrument-code"]),
    (props.isFutures)
      ? (_openBlock(), _createBlock(_unref(OtLozenge), {
          key: 1,
          filled: false,
          text: _ctx.$t('fundamentals.perpetual.short'),
          class: "order-market__lozenge"
        }, null, 8, ["text"]))
      : _createCommentVNode("", true)
  ]))
}
}

})